import React from 'react'
import BillingAddress from './BillingAddress';
import Typography from '@material-ui/core/Typography';

const BillingPage = ({ viewerObj, connectedStripeId }) => {
  
  return (
    <>
      <Typography variant="h4" >Your Address</Typography>
      <BillingAddress 
        customerId={viewerObj.stripeId} 
        connectedStripeId={connectedStripeId}/>
    </>
  )
}

export default BillingPage